var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('vue-apex-charts',{attrs:{"type":"line","height":_vm.window.height,"width":_vm.window.width,"options":_vm.chartConfig.chartOptions,"series":_vm.chartConfig.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }